import { IExercise, ExerciseData, drawQuestionResult } from '../exercise';
import { PdfUnit, PdfRect } from '../../pdf/pdf';
import { GUtil } from '../../pdf/gutil';

export class ExeHeaderName implements IExercise {
  readonly name = 'HeaderName';
  readonly fixedHeight = PdfUnit.FromMillimeters(20);
  readonly noWindow = true;
  readonly injectEq = false;
  readonly injectAbc = false;

  private margin = PdfUnit.FromMillimeters(2);

  draw(data: ExerciseData): void {
    const label1 = data.data.lang['Test_Name'] ?? 'Jm\u00e9no:';
    const label2 = data.data.lang['Test_Date'] ?? 'Datum:';

    const size1 = data.page.measureString(label1, GUtil.exerciseFont);

    const sx = data.rect.width * 0.7;

    const r1 = new PdfRect(data.rect.x, data.rect.y, sx - this.margin, size1.height);
    const r2 = new PdfRect(data.rect.x + sx, data.rect.y, data.rect.width - sx, size1.height);

    drawQuestionResult(data, label1, r1);
    drawQuestionResult(data, label2, r2);
  }
}
